import { ApiOrg } from 'api/org/types/ApiOrg';
import { PageToolbar } from 'components/Page/PageToolbar';

import { ActionButtons } from './ActionButtons';

type Props = {
  org: ApiOrg;
  isPublished?: boolean;
  editMode: boolean;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setEditMode: (...args: Array<any>) => any;
};

export function Toolbar({ org, isPublished, editMode, setEditMode }: Props) {
  return (
    <PageToolbar
      centered
      message={
        org.isFrozen
          ? getText(
              'Your organization has been frozen. Please contact the Idealist Community Support Team to resolve this issue.',
            )
          : getText('You are an administrator of this organization')
      }
      tools={
        <ActionButtons
          org={org}
          isPublished={isPublished}
          editMode={editMode}
          setEditMode={setEditMode}
        />
      }
    />
  );
}
